import {
  ENTER_KEY,
  ESC_KEY
} from './const';
import {
  end,
  showMessage,
  start,
  getResponseByMode
} from './utils';
import {
  mobileMenu
} from '../base';

export class Dialog {
  constructor(options) {
    this._elem = null;
    this._link = null;
    this._id = null;
    this._callback = {};
    this.payload = null;
    this.cls = '.js-dialog';

    this._overlay = null;
    this._container = null;
    this._btnClose = null;
    this._btnCancel = null;

    this._btnClickHandler = this._btnClickHandler.bind(this);
    this._documentKeydownHandler = this._documentKeydownHandler.bind(this);
    this._closebtnClickHandler = this._closebtnClickHandler.bind(this);
    this._closebtnKeydownHandler = this._closebtnKeydownHandler.bind(this);
    this._cancelBtnClickHandler = this._cancelBtnClickHandler.bind(this);
    this._cancelBtnKeydownHandler = this._cancelBtnKeydownHandler.bind(this);

    Object.assign(this, options);

    this._init();
  }

  getLink() {
    return this._link;
  }

  getElem() {
    return this._elem;
  }

  setAfterOpenCallback(callback) {
    this._callback.afterOpen = callback;
  }

  open(id, data = null) {
    return new Promise((resolve) => {
      this._id = id;
      if (data !== null) {
        this._setPayload(data);
      }
      const elem = document.querySelector(`#dialog-${this._id}`);
      if (elem) {
        if (data !== null) {
          this._insert(elem);
        }
        this._show(elem, resolve);
      } else {
        this._loadHtml(resolve);
      }
    });
  }

  preload() {
    this._container.classList.toggle('dialog__container--update');
  }

  hide(elem) {
    if (elem) {
      this._elem = elem;
    }
    document.body.classList.remove('overflow');
    this._elem.classList.remove('dialog--show');
    this._overlay.classList.remove('overlay--show');

    document.removeEventListener('keydown', this._documentKeydownHandler);
    this._btnClose.removeEventListener('click', this._closebtnClickHandler);
    this._btnClose.removeEventListener('keydown', this._closebtnKeydownHandler);
    if (this._btnCancel) {
      this._btnCancel.removeEventListener('click', this._cancelBtnClickHandler);
      this._btnCancel.removeEventListener('keydown', this._cancelBtnKeydownHandler);
    }
  }

  _show(elem, resolve) {
    if (this._elem) {
      this.hide();
      this._elem = null;
    }
    if (elem) {
      this._elem = elem;
    }
    if (this._elem === null) {
      showMessage('Произошла ошибка при загрузке модального окна');
      return;
    }
    if (mobileMenu.getElem()) {
      mobileMenu.hide();
    }

    this._overlay = document.querySelector('.overlay');
    this._container = this._elem.querySelector('.dialog__container');
    this._btnClose = this._elem.querySelector('.dialog__close');
    this._btnCancel = this._elem.querySelector('.dialog__button--cancel');

    document.body.classList.add('overflow');
    this._elem.classList.add('dialog--show');
    this._overlay.classList.add('overlay--show');

    document.addEventListener('keydown', this._documentKeydownHandler);
    this._btnClose.addEventListener('click', this._closebtnClickHandler);
    this._btnClose.addEventListener('keydown', this._closebtnKeydownHandler);
    if (this._btnCancel) {
      this._btnCancel.addEventListener('click', this._cancelBtnClickHandler);
      this._btnCancel.addEventListener('keydown', this._cancelBtnKeydownHandler);
    }
    this._elem.focus();

    if ('afterOpen' in this._callback) {
      this._callback.afterOpen();
    }

    resolve(this);
  }

  _setPayload(data) {
    this.payload = {
      link: data.link,
      title: data.title,
      body: data.body,
      callback: data.callback,
      action: data.action
    };
  }

  _init(container = document) {
    const elems = container.querySelectorAll(this.cls);
    elems.forEach((elem) => {
      this._initOne(elem);
    });
  }

  _initOne(elem) {
    elem.addEventListener('click', this._btnClickHandler);
  }

  async _loadHtml(resolve) {
    try {
      start();

      const config = this._getResponse();
      const response = await fetch(config);

      if (!response.ok) {
        throw new Error('Неуспешный запрос');
      }
      const data = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      const elem = doc.querySelector('.dialog');
      document.body.appendChild(elem);
      this._init(elem);
      this._loadJs(elem.dataset.js);
      this._show(elem, resolve);
    } catch (error) {
      showMessage(error.message);
    } finally {
      end();
    }
  }

  async _loadJs(boolean) {
    if (boolean) {
      return await import('./modal/' + this._id + '.js');
    } else {
      return false;
    }
  }

  _insert(elem) {
    const dialogTitle = elem.querySelector('.dialog__title');
    const dialogBody = elem.querySelector('.dialog__inner');

    const title = document.querySelector(this.payload.title);
    const body = document.querySelector(this.payload.body);
    const link = this.payload.link;
    const callback = this.payload.callback;
    const cls = this.cls.slice(1);

    if (title) {
      dialogTitle.textContent = title.textContent;
    }

    if (body) {
      dialogBody.appendChild(body);
    }

    link.classList.add(cls);
    link.dataset.dialog = this._id;
    link.removeEventListener('click', callback);
    this.payload = null;
    this._initOne(link);
  }

  _getResponse() {
    const mock = `mocks/${this._id}.html`;
    const real = this._getRealResponse();

    return getResponseByMode(mock, real);
  }

  _getRealResponse() {
    if (this._link) {
      return this._link.dataset.action ? this._link.dataset.action : `/shop/modal?type=${this._id}`;
    } else if (this.payload && this.payload.action !== undefined) {
      return this.payload.action;
    } else {
      return `/shop/modal?type=${this._id}`;
    }
  }

  _btnClickHandler(evt) {
    evt.preventDefault();
    this._link = evt.currentTarget;
    this.open(this._link.dataset.dialog);
  }

  _documentKeydownHandler(evt) {
    if (evt.key === ESC_KEY) {
      this.hide();
    }
  }

  _closebtnClickHandler() {
    this.hide();
    document.removeEventListener('keydown', this._documentKeydownHandler);
  }

  _closebtnKeydownHandler(evt) {
    if (evt.key === ENTER_KEY) {
      this.hide();
    }
  }

  _cancelBtnClickHandler() {
    this.hide();
    document.removeEventListener('keydown', this._documentKeydownHandler);
  }

  _cancelBtnKeydownHandler(evt) {
    if (evt.key === ENTER_KEY) {
      this.hide();
    }
  }
}
